// 仮画像生成ユーティリティ
export const createPlaceholderImage = (width: number, height: number, text: string, bgColor: string = '#333'): string => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  
  if (!ctx) return '';
  
  // 背景色を設定
  ctx.fillStyle = bgColor;
  ctx.fillRect(0, 0, width, height);
  
  // テキストを設定
  ctx.fillStyle = '#fff';
  ctx.font = `${Math.min(width, height) / 8}px Arial`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(text, width / 2, height / 2);
  
  return canvas.toDataURL();
};

// 画像スライドショー用の仮画像データ
export const placeholderImages = {
  vrGoggles: createPlaceholderImage(800, 600, 'VRゴーグル', '#1a1a2e'),
  kiyomizu: createPlaceholderImage(800, 600, '清水寺', '#16213e'),
  tokyoCity: createPlaceholderImage(800, 600, '東京の町', '#0f3460')
};

// セキュリティ対応: 画像URLのサニタイズ
export const sanitizeImageUrl = (url: string): string => {
  try {
    const urlObj = new URL(url, window.location.origin);
    // HTTPSまたはdata:スキームのみ許可
    if (urlObj.protocol === 'https:' || urlObj.protocol === 'data:') {
      return urlObj.toString();
    }
    return '';
  } catch {
    return '';
  }
};

// レスポンシブ画像サイズ計算
export const getResponsiveImageSize = () => {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  
  if (screenWidth <= 1170) {
    // モバイル
    return {
      width: Math.min(screenWidth * 0.9, 400),
      height: Math.min(screenHeight * 0.6, 300),
      isMobile: true
    };
  } else {
    // デスクトップ
    return {
      width: Math.min(screenWidth * 0.6, 800),
      height: Math.min(screenHeight * 0.6, 600),
      isMobile: false
    };
  }
};